import gql from 'graphql-tag';

export const GET_AVAILABLE_PLANS = gql`
  query GetAvailablePlans {
    getAvailablePlans {
      uuid
      name
      description
      price
      durationDays
      maxUsers
      maxProducts
      features
    }
  }
`;

export const GET_CURRENT_SHOP_SUBSCRIPTION = gql`
  query GetCurrentShopSubscription {
    getCurrentShopSubscription {
      uuid
      plan {
        uuid
        name
        price
        durationDays
      }
      startDate
      endDate
      isActive
      isExpired
      inGracePeriod
      isUsable
    }
  }
`;

export const INITIATE_SUBSCRIPTION_PAYMENT = gql`
  mutation InitiateSubscriptionPayment($planUuid: String!, $paymentMethod: String!, $phoneNumber: String) {
    initiateSubscriptionPayment(planUuid: $planUuid, paymentMethod: $paymentMethod, phoneNumber: $phoneNumber) {
      ussdPushSent
      checkoutUrl
      payment {
        uuid
        status
      }
      response {
        status
        message
      }
    }
  }
`;

export const CHECK_SUBSCRIPTION_PAYMENT_STATUS = gql`
  query CheckSubscriptionPaymentStatus($orderUuid: String!) {
    checkSubscriptionPaymentStatus(orderUuid: $orderUuid) {
      status
      subscription {
        plan {
          name
        }
        endDate
        isActive
      }
    }
  }
`;
